export const SELECT_CLUSTER = 'SELECT_CLUSTER';

export const selectClusterDetails = cluster => ({
  type: SELECT_CLUSTER,
  data: cluster,
});
